import fromEnum from '@/scripts/io-ts/fromEnum';

export enum Status {
    AWAITING_UPLOAD = 'awaiting_upload',
    CREATED = 'created',
    CONVERSION = 'conversion',
    READY = 'ready',
    FAILED = 'failed',
}

export const StatusC = fromEnum('Status', Status);
